import { render, staticRenderFns } from "./VUserForm.vue?vue&type=template&id=900703fa&"
import script from "./VUserForm.vue?vue&type=script&lang=js&"
export * from "./VUserForm.vue?vue&type=script&lang=js&"
import style0 from "./VUserForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports